// Invoice Service API calls
import axios from "axios";

const JTL_API_URL = import.meta.env.VITE_JTL_API_URL || "/api/v1/jtl";

// Create axios instance for Invoice service
const JtlApiClient = axios.create({
  baseURL: JTL_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include auth token
JtlApiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Health check
export const jtlHealthApi = {
  healthCheck: () => {
    return JtlApiClient.get("/health");
  },
};

// WebSocket connection for real-time updates
export const createJtlWebSocket = (onMessage, onError) => {
  // Ensure ws protocol and correct path
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  const host = window.location.host; // e.g. localhost:3000 or mydomain.com
  // If JTL_API_URL is relative like "/api/v1", we need to prepend host
  // But if it's absolute, we replace protocol.

  let wsBaseUrl = JTL_API_URL;
  if (JTL_API_URL.startsWith("/")) {
    wsBaseUrl = `${protocol}//${host}${JTL_API_URL}`;
  } else {
    wsBaseUrl = JTL_API_URL.replace(/^http/, "ws");
  }

  const wsUrl = `${wsBaseUrl}/jtl/ws`;

  const ws = new WebSocket(wsUrl);
  let keepAliveInterval;

  ws.onopen = (event) => {
    // Send periodic keepalive messages
    keepAliveInterval = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.send(
          JSON.stringify({ type: "ping", timestamp: new Date().toISOString() }),
        );
        console.log("Sent keepalive ping");
      }
    }, 30000); // Send ping every 30 seconds
  };

  ws.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);

      if (onMessage) {
        onMessage(data);
      }
    } catch (error) {}
  };

  ws.onerror = (error) => {
    if (onError) {
      onError(error);
    }
  };

  ws.onclose = (event) => {
    // Clear the keepalive interval when connection closes
    if (keepAliveInterval) {
      clearInterval(keepAliveInterval);
    }
  };

  return ws;
};

export default JtlApiClient;
